<template>
  <v-container>
    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3>
        <v-card v-if="userid">
          <v-card-text>
            <v-container>
                    <v-btn @click="logout">
                      Sign out
                    </v-btn>              
            </v-container>
          </v-card-text>
        </v-card>

        <v-card v-else >
          <v-card-title class="subheading font-weight-bold ">
            Login Using An Existing Account:
          </v-card-title>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSignin">
                <v-layout row>
                  <v-flex xs12 >
                    <!--
                    <div class="text-xs-center ">
                      <v-btn color="blue darken-1" dark :disabled="loading" :loading="loading" @click.prevent="onSigninLinkedin"><v-icon left dark>fab fa-linkedin</v-icon>Login with LinkedIn
                        <span slot="loader" class="custom-loader">
                        
                       </span>
                      </v-btn>
                    </div>     
                    -->               
                    <div class="text-xs-center">
                      <v-btn  color="red" dark :disabled="loading" :loading="loading" @click.prevent="onSigninGoogle"><v-icon left dark>fab fa-google</v-icon>Login with Google
                        
                        <span slot="loader" class="custom-loader">
                        
                       </span>
                      </v-btn>
                    </div>
                    <div class="text-xs-center">
                      <v-btn  color="blue darken-4" dark :disabled="loading" :loading="loading" @click.prevent="onSigninFacebook"><v-icon left dark>fab fa-facebook</v-icon>Login with Facebook

                        <span slot="loader" class="custom-loader">
                        
                       </span>
                      </v-btn>
                    </div>
                   
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'

  export default {
    data () {
      return {
        email: '',
        password: ''
      }
    },
    created(){
        if (this.$store.getters.member !== null && this.$store.getters.member !== undefined) {             
           console.log('pushingrouter to  /profile from signin.vue (created)')
          this.$router.push('/profile')
        }else if (this.$store.getters.user !== null && this.$store.getters.user !== undefined) {             
          console.log('pushingrouter to  /register from signin.vue (created)')
          this.$router.push('/register')
        }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },      
      userid () {
        if(this.$store.getters.user === null){
          return null
        }else{
          return this.$store.getters.user.id
        }
        
      },      
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    watch: {
      member (value) {
        if (value !== null && value !== undefined) {             
           console.log('watching member: ', value)
           console.log('pushingrouter to  /profile from signin.vue (member watch)')
            this.$router.push('/profile')
        }
      }, 
      user (value) {
        if (value !== null && value !== undefined) {             
           console.log('watching user: ', value)
           console.log('pushingrouter to  /register from signin.vue (user watch)')
            this.$router.push('/register')
        }
      }
     
    },
    methods: {
      onSignin () {
        
        
        this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
      },
      onSigninLinkedin () {

    
        this.$auth.authenticate('github').then(function () {
          // Execute application logic after successful social authentication
        })
    
        //this.$store.dispatch('signUserInLinkedIn',{ user, requestOptions })
                
      },      
      onSigninGoogle () {
        
        this.$store.dispatch('retrieveGoogleMember').then(user => {
          //console.log('user', user)
          var storeMember = this.$store.getters.member
          var storeUser = this.$store.getters.user
          if(storeMember && storeMember!==undefined && storeMember!==null){
              this.$router.push('/profile')
          }else if(storeUser && storeUser!==undefined && storeUser!==null){
              this.$router.push('/register')
          }
          /*
          if(user && user.user && user.user.id !== null){
            console.log('pushingrouter to  /register from signin.vue (onSigninGoogle)')
            this.$router.push('/register')
          }
          */
        })

        //this.$store.dispatch('signUserInGoogle')
      },
      onSigninFacebook () {
        
        this.$store.dispatch('retrieveFacebookMember').then(user => {
          //console.log('user', user)
          var storeMember = this.$store.getters.member
          var storeUser = this.$store.getters.user
          if(storeMember && storeMember!==undefined && storeMember!==null){
            this.$router.push('/profile')
          }else if(storeUser && storeUser!==undefined && storeUser!==null){
            this.$router.push('/register')
          }
          /*
          if(user && user.user && user.user.id !== null){
            console.log('pushingrouter to  /register from signin.vue (onSigninGoogle)')
            this.$router.push('/register')
          }
          */
        })

        //this.$store.dispatch('signUserInGoogle')
      },      
      onSigninFacebook () {
        this.$store.dispatch('signUserInFacebook')
      },
      onSigninGithub () {
        this.$store.dispatch('signUserInGithub')
      },
      onSigninTwitter () {
        this.$store.dispatch('signUserInTwitter')
      },
      onResetPassword () {
        if (this.email === '') {
          return this.$store.dispatch('setError', {message: 'Email can not be blnak'})
        }
        this.$store.dispatch('resetPasswordWithEmail', {email: this.email})
      },
      onDismissed () {
        this.$store.dispatch('clearError')
      },
      logout (){
        this.$store.commit('resetState')
      }         
    }
  }
</script>